<template lang="pug">
  .wrapper(v-if="isVisible" data-aos="fade-right")
    .path(:class="{ 'path--selected': isSelected }")
      .path__text.mr-2
        span.path__name(v-line-clamp="isSelected ? 0 : 1") {{ path.name }}
        span.path__files.mr-2 файлов: {{ relatedFiles.length }}
        v-btn.edit-icon(text x-small @click.prevent.stop="onEdit")
          v-icon(small) edit
        v-btn.edit-icon(text x-small @click.prevent.stop="onDelete")
          v-icon(small) delete
      v-icon.path__icon(color="#FFFFFF") {{ isSelected ? 'menu_open' : 'keyboard_arrow_right'}}
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'file-store-explorer-path',

  props: {
    path: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('fileStore', ['documentsByPath', 'templatesByPath']),
    ...mapState('fileStore', { 
      isSelected (state) {
        return state.path.id == this.path.id
      }
    }),

    isVisible () {
      // return this.path.isFolder || this.relatedFiles.length > 0
      return true
    },

    relatedFiles () {
      return this.path.isFolder ? this.documentsByPath(this.path) : this.templatesByPath(this.path)
    }
  },

  methods: {
    onEdit () {
      this.$emit('edit', this.path)
    },

    onDelete () {
      this.$emit('delete', this.path)
    }
  },

  data () {
    return {
      dialog: {
        confirm: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #757575;
  margin-bottom: 1px;

  &:hover {
    background: transparentize($color: #C4C4C4, $amount: 0.5);
    // .path__files {
    //   display: none;
    // }
    .edit-icon {
      display: inline;
    }
  }
}

.edit-icon {
  // position: absolute;
  // top: 1px;
  // left: 4px;
  // right: 1px;
  display: none;
}

.path {
  padding: 16px 8px 16px 16px;
  transition: .3s all ease;

  display: flex;
  justify-content: space-between;
  
  line-height: 20px;

  &__text {
    flex-grow: 1;
  }

  &__name {
    word-wrap: break-word;
  }
  
  &__files { 
    font-size: 12px;
    color: #C4C4C4;
  }

  &__icon {
    font-weight: inherit;
  }

  &--selected {
    border-left: 12px solid #00BCD4;
  }
}
</style>